import { render, staticRenderFns } from "./BaseFormNewBarrier.vue?vue&type=template&id=03f9b9b4&scoped=true"
import script from "./BaseFormNewBarrier.vue?vue&type=script&lang=js"
export * from "./BaseFormNewBarrier.vue?vue&type=script&lang=js"
import style0 from "./BaseFormNewBarrier.vue?vue&type=style&index=0&id=03f9b9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f9b9b4",
  null
  
)

export default component.exports